// extracted by mini-css-extract-plugin
module.exports = {"imagenbg":"hero-module--imagenbg--16zlF","titulo":"hero-module--titulo--1sq0H"};